let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6dgQT")).then(() => parcelRequire('fVZ2Y'));